import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import materialConfigEmptyImage from "@/assets/agent/material-config-empty@3x.webp";

export const MaterialConfigEmptyImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[materialConfigEmptyImage]}
      {...props}
    />
  );
};

MaterialConfigEmptyImage.displayName = 'MaterialConfigEmptyImage';
